module.exports = __webpack_public_path__ + "static/Korina-684b62916b976c15a73eb3eecd07c9ab.jpg";